/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// import { useState } from "react";
import { Menu, Button } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/goguma-logo.svg";
import { useAuth } from "../../contexts/AuthContext";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { isAuthenticated, logout } = useAuth();

  const handleSignOut = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const stocks = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 17V7L9 1L15 7V17H11V13H7V17H3Z"
        fill={color}
      />
      <path
        d="M2 3L6 7L10 3L18 11"
        fill={color}
      />
    </svg>,
  ];

  const tables = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const billing = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const rtl = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const profile = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const signin = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const dividend = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10 6C10.5523 6 11 6.44772 11 7V9.58579L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L9.29289 10.7071C9.10536 10.5196 9 10.2652 9 10V7C9 6.44772 9.44772 6 10 6Z"
        fill={color}
      />
    </svg>,
  ];

  const correlation = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2C2.55228 2 3 2.44772 3 3V14C3 14.5523 3.44772 15 4 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H4C2.34315 17 1 15.6569 1 14V3C1 2.44772 1.44772 2 2 2Z"
        fill={color}
      />
      <path
        d="M6 12C6.55228 12 7 11.5523 7 11V9C7 8.44772 6.55228 8 6 8C5.44772 8 5 8.44772 5 9V11C5 11.5523 5.44772 12 6 12Z"
        fill={color}
      />
      <path
        d="M10 12C10.5523 12 11 11.5523 11 11V6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6V11C9 11.5523 9.44772 12 10 12Z"
        fill={color}
      />
      <path
        d="M14 12C14.5523 12 15 11.5523 15 11V4C15 3.44772 14.5523 3 14 3C13.4477 3 13 3.44772 13 4V11C13 11.5523 13.4477 12 14 12Z"
        fill={color}
      />
    </svg>,
  ];

  const dataEntry = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3ZM4 5H16V15H4V5Z"
        fill={color}
      />
      <path
        d="M6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
        fill={color}
      />
      <path
        d="M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H6Z"
        fill={color}
      />
      <path
        d="M13 11C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11Z"
        fill={color}
      />
    </svg>,
  ];

  const indicators = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2C2.55228 2 3 2.44772 3 3V14C3 14.5523 3.44772 15 4 15H17C17.5523 15 18 15.4477 18 16C18 16.5523 17.5523 17 17 17H4C2.34315 17 1 15.6569 1 14V3C1 2.44772 1.44772 2 2 2Z"
        fill={color}
      />
      <path
        d="M6 12C6.55228 12 7 11.5523 7 11V7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7V11C5 11.5523 5.44772 12 6 12Z"
        fill={color}
      />
      <path
        d="M10 12C10.5523 12 11 11.5523 11 11V4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V11C9 11.5523 9.44772 12 10 12Z"
        fill={color}
      />
      <path
        d="M14 12C14.5523 12 15 11.5523 15 11V9C15 8.44772 14.5523 8 14 8C13.4477 8 13 8.44772 13 9V11C13 11.5523 13.4477 12 14 12Z"
        fill={color}
      />
      <circle cx="6" cy="5" r="1" fill={color} />
      <circle cx="10" cy="2" r="1" fill={color} />
      <circle cx="14" cy="7" r="1" fill={color} />
    </svg>,
  ];

  const trading = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C3.44772 2 3 2.44772 3 3V17C3 17.5523 3.44772 18 4 18C4.55228 18 5 17.5523 5 17V3C5 2.44772 4.55228 2 4 2Z"
        fill={color}
      />
      <path
        d="M8 6C7.44772 6 7 6.44772 7 7V17C7 17.5523 7.44772 18 8 18C8.55228 18 9 17.5523 9 17V7C9 6.44772 8.55228 6 8 6Z"
        fill={color}
      />
      <path
        d="M12 10C11.4477 10 11 10.4477 11 11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V11C13 10.4477 12.5523 10 12 10Z"
        fill={color}
      />
      <path
        d="M16 4C15.4477 4 15 4.44772 15 5V17C15 17.5523 15.4477 18 16 18C16.5523 18 17 17.5523 17 17V5C17 4.44772 16.5523 4 16 4Z"
        fill={color}
      />
      <path
        d="M2 8L6 4L10 8L18 2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>,
  ];

  const accountBalance = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4C2.89543 4 2 4.89543 2 6V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V6C18 4.89543 17.1046 4 16 4H4ZM4 6H16V8H4V6ZM4 10H16V14H4V10Z"
        fill={color}
      />
      <path
        d="M6 12C6.55228 12 7 11.5523 7 11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12Z"
        fill="white"
      />
      <path
        d="M14 12H10V11H14V12Z"
        fill="white"
      />
    </svg>,
  ];

  const transactions = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 4.34315 4.34315 3 6 3H14C15.6569 3 17 4.34315 17 6V14C17 15.6569 15.6569 17 14 17H6C4.34315 17 3 15.6569 3 14V6ZM6 5C5.44772 5 5 5.44772 5 6V7H15V6C15 5.44772 14.5523 5 14 5H6ZM5 9V14C5 14.5523 5.44772 15 6 15H14C14.5523 15 15 14.5523 15 14V9H5Z"
        fill={color}
      />
      <path
        d="M7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11H7Z"
        fill={color}
      />
      <path
        d="M11 11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11H11Z"
        fill={color}
      />
    </svg>,
  ];

  const signup = [
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      key={0}
    >
      <path
        d="M0,2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8Z"
        transform="translate(4 4)"
        fill={color}
      />
      <path
        d="M2,0A2,2,0,0,0,0,2V8a2,2,0,0,0,2,2V4A2,2,0,0,1,4,2h6A2,2,0,0,0,8,0Z"
        fill={color}
      />
    </svg>,
  ];

  return (
    <>
      <div className="brand">
        <img src={logo} alt="" />
        <span>Goguma's Assets</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/dashboard">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
              }}
            >
              {dashboard}
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/account-balance">
            <span
              className="icon"
              style={{
                background: page === "account-balance" ? color : "",
              }}
            >
              {accountBalance}
            </span>
            <span className="label">Account Balance</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/dividend">
            <span
              className="icon"
              style={{
                background: page === "dividend" ? color : "",
              }}
            >
              {dividend}
            </span>
            <span className="label">Dividend</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/data-entry">
            <span
              className="icon"
              style={{
                background: page === "data-entry" ? color : "",
              }}
            >
              {dataEntry}
            </span>
            <span className="label">Data Entry</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/stocks">
            <span
              className="icon"
              style={{
                background: page === "stocks" ? color : "",
              }}
            >
              {stocks}
            </span>
            <span className="label">Stocks</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/indicators">
            <span
              className="icon"
              style={{
                background: page === "indicators" ? color : "",
              }}
            >
              {indicators}
            </span>
            <span className="label">Indicators</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="7">
          <NavLink to="/correlation">
            <span
              className="icon"
              style={{
                background: page === "correlation" ? color : "",
              }}
            >
              {correlation}
            </span>
            <span className="label">Correlation</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="8">
          <NavLink to="/transactions">
            <span
              className="icon"
              style={{
                background: page === "transactions" ? color : "",
              }}
            >
              {transactions}
            </span>
            <span className="label">Transactions</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="9">
          <NavLink to="/profits">
            <span
              className="icon"
              style={{
                background: page === "profits" ? color : "",
              }}
            >
              {billing}
            </span>
            <span className="label">Profits</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="10">
          <NavLink to="/trading">
            <span
              className="icon"
              style={{
                background: page === "trading" ? color : "",
              }}
            >
              {trading}
            </span>
            <span className="label">Auto Trading</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item className="menu-item-header" key="11">
          Account Pages
        </Menu.Item>
        <Menu.Item key="12">
          <NavLink to="/profile">
            <span
              className="icon"
              style={{
                background: page === "profile" ? color : "",
              }}
            >
              {profile}
            </span>
            <span className="label">Profile</span>
          </NavLink>
        </Menu.Item>
        {isAuthenticated ? (
          <Menu.Item key="13">
            <a onClick={handleSignOut} style={{ cursor: 'pointer' }}>
              <span className="icon">{signin}</span>
              <span className="label">Sign Out</span>
            </a>
          </Menu.Item>
        ) : (
          <Menu.Item key="13">
            <NavLink to="/sign-in">
              <span className="icon">{signin}</span>
              <span className="label">Sign In</span>
            </NavLink>
          </Menu.Item>
        )}
        {/* <Menu.Item key="10">
          <NavLink to="/sign-up">
            <span className="icon">{signup}</span>
            <span className="label">Sign Up</span>
          </NavLink>
        </Menu.Item> */}
      </Menu>
      {/* <div className="aside-footer">
        <div
          className="footer-box"
          style={{
            background: color,
          }}
        >
          <span className="icon" style={{ color }}>
            {dashboard}
          </span>
          <h6>Need Help?</h6>
          <p>Please check our docs</p>
          <Button type="primary" className="ant-btn-sm ant-btn-block">
            DOCUMENTATION
          </Button>
        </div>
      </div> */}
    </>
  );
}

export default Sidenav;
